import { type Ref, forwardRef } from "react";
import type { SVGProps } from "react";
const PeopleSolid = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    width={24}
    height={24}
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M11 8c0 1.66-1.34 3-3 3S5 9.66 5 8s1.34-3 3-3 3 1.34 3 3M1 17.537C1 14.61 5.667 13 8 13s7 1.61 7 4.537v.963a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5zM19 8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3m-2 10.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-.963C23 14.61 18.333 13 16 13c-.428 0-.934.054-1.476.16 1.285.95 2.476 2.38 2.476 4.377z"
      clipRule="evenodd"
    />{" "}
  </svg>
);
const ForwardRef = forwardRef(PeopleSolid);
export default ForwardRef;
